import React from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import AppContext from '../../context';

// ─── Estilos ─────────────────────────────────────────────────────────────────

const Container = styled.div`
  text-align: center;
  padding: 20px 10px 10px;
`;

const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  border: 3px solid #e83535;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: #e83535;
  font-size: 2rem;
`;

const Title = styled.h3`
  color: #e83535 !important;
  font-size: 1.4rem !important;
  font-weight: 700;
  margin-bottom: 20px;
`;

const WarningBox = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  padding: 14px 18px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
  margin-bottom: 24px;
  font-size: 0.95rem;
  color: #7d5a00;

  i {
    margin-top: 2px;
    min-width: 18px;
    color: #e6a817;
    font-size: 1rem;
  }

  a {
    color: #7d5a00;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const MainButton = styled.button`
  background-color: #2554b8;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 12px 20px;
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0 auto 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  max-width: 300px;
  box-shadow: 0 4px 6px rgba(37, 84, 184, 0.2);

  &:hover {
    background-color: #1d439b;
    box-shadow: 0 6px 8px rgba(37, 84, 184, 0.3);
    transform: translateY(-1px);
  }

  i {
    font-size: 1.1rem;
  }
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 10px;

  a {
    font-size: 0.95rem;
    font-weight: 600;
    color: #2554b8;
    text-decoration: underline;
    cursor: pointer;
  }
`;


const SUPPORT_PHONE = '5511966466526';
const COMMERCIAL_PHONE = '5511966466526';

/**
 * Modal de aviso: certificado digital A1 não informado.
 * Exibido automaticamente ao carregar as páginas de Produtos e Clientes
 * quando a filial não possui certificado vinculado.
 */
export default function NoCertificateWarning() {
  const context = React.useContext(AppContext);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const branch = context.currentBranch;
    // Mostra apenas se o contexto já carregou e não há certificado
    if (branch && Object.keys(branch).length > 0 && !branch.certificate) {
      setShow(true);
    }
  }, [context.currentBranch]);

  function goToCertificate() {
    setShow(false);
    window.location.href = '/digital-certificate';
  }

  function openWhatsApp(phone) {
    window.open(`https://api.whatsapp.com/send?phone=${phone}`, '_blank', 'noopener,noreferrer');
  }

  return (
    <Modal
      show={show}
      onHide={() => { }}
      centered
      size="md"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        <Container>
          <IconCircle>
            <i className="fas fa-times" />
          </IconCircle>

          <Title>Certificado digital A1 não informado</Title>

          <WarningBox>
            <i className="fas fa-exclamation-triangle" />
            <span>
              Você não possui certificado digital vinculado ao sistema. É necessário anexar o arquivo .pfx para continuar.
              {' '}Caso não tenha certificado fale com o nosso time comercial.
            </span>
          </WarningBox>

          <MainButton onClick={goToCertificate}>
            <i className="fas fa-file-signature" /> Anexar Certificado Agora
          </MainButton>

          <ActionRow>
            <a onClick={() => openWhatsApp(COMMERCIAL_PHONE)}>
              <i className="fab fa-whatsapp" /> Falar com Comercial
            </a>
            <a onClick={() => openWhatsApp(SUPPORT_PHONE)}>
              <i className="fab fa-whatsapp" /> Falar com suporte
            </a>
          </ActionRow>
        </Container>
      </Modal.Body>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/_components/NoCertificateWarning/index.jsx